export const pathHelper = {
  findRoot: (path) => path.slice(0, path.indexOf(':') > 0 ? path.indexOf(':') - 1 : path.length),
}
